import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { Box } from "@mui/material";

import * as BotpressSessionActions from "../../state/redux/botpressSession";
import { deepCopyObject } from "../../utils/helpers.js";
import BotpressMembersTable from "../ui/botpressMembersTable.js";
import Widget from "../ui/widget.js";
import WidgetSkeleton from "../ui/widgetSkeleton.js";
import WidgetSurveyContent from "../ui/widgetSurveyContent.js";
import WidgetTitle from "../ui/widgetTitle.js";

const BotpressMembers = ({
  members,
  memberPagination,
  memberPageLoading,
  searchMembersRequest,
  widgetSize = "medium",
  minHeight = "333px",
}) => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    if (members != null) {
      setRows(members);
    } else {
      setRows([]);
    }
  }, [members]);

  const onRequestNewPage = async pagination => {
    try {
      searchMembersRequest(pagination);
    } catch (error) {
      console.error("Error getting member table rows", error);
      setRows([]);
    }
  };

  const onRefreshTable = () => {
    let newPagination = deepCopyObject(memberPagination || {});
    newPagination["invalidateCache"] = true;
    onRequestNewPage(newPagination);
  };

  return (
    <Widget widgetSize={widgetSize} minHeight={minHeight}>
      <WidgetTitle title={"Members"} text={rows != null ? `${rows.length} Members` : "Members"} />

      {rows == null && <WidgetSkeleton />}

      {rows != null && (
        <WidgetSurveyContent>
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              opacity: memberPageLoading ? 0.45 : 1,
              pointerEvents: memberPageLoading ? "none" : "auto",
              transition: "opacity 0.25s ease",
            }}
          >
            <BotpressMembersTable
              data={rows}
              onRequestNewPage={onRequestNewPage}
              dataReduxPagination={memberPagination}
              onRefreshTable={onRefreshTable}
            />
          </Box>
        </WidgetSurveyContent>
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  members: state.botpressSession.members,
  memberPagination: state.botpressSession.memberPagination,
  memberPageLoading: state.botpressSession.memberPageLoading,
});

const mapDispatchToProps = {
  searchMembersRequest: BotpressSessionActions.searchMembersRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BotpressMembers);
